module.exports = __webpack_public_path__ + "static/img/share1.e9f6857.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/activity/images/share1.png
// module id = lqpf
// module chunks = 1